<template>
  <div id="funcionalidade-customizada-detalhe">
    <funcionalidade-header :titulo="tituloNavegacao"/>
    <solicitacao-detalhe/>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoDetalhe from '@/components/TemplateSolicitacao/componentes/SolicitacaoDetalhe'
import { mapState } from 'vuex'

export default {
  name: 'FuncionalidadeCustomizadaDetalhe',
  components: { SolicitacaoDetalhe, FuncionalidadeHeader },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.tituloTelaDetalhe || this.funcionalidade.parametros.dashboard.nome
    }
  }
}
</script>
